import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Utility from '@/Common/Utility';
import PlugableControlBase from '@/Common/PlugableControlBase';
import Vue from 'vue';
import routeConfig from '@/router';
import apiService from '@/Common/ApiService';
export default {
  name: "RichEditor",
  data: function data() {
    return {
      ControlId: "",
      RichHtml: "",
      //不想被外部控制的 屬性 , 但建構時依然會建構
      m_ControlInstanceVues: [],
      m_CommentNodes: [],
      m_LastInputTime: new Date(),
      m_LastTriggerChangeTime: new Date("1900/1/1"),
      m_BrowserHtml: ""
    };
  },
  props: ["value", "Editable"],
  methods: {
    OnChange: function OnChange(e) {
      alert("OnRichEditor Change");
    },
    OnInput: function OnInput(e) {
      var contentHtml;
      this.m_LastInputTime = new Date();
      e.cancelBubble = true;

      if (e.inputType == "historyRedo" || e.inputType == "historyUndo") {
        this.RichHtml = this.GetRichHtml();
        this.m_LastTriggerChangeTime = new Date();
        this.EmitChange();
      }
    },
    OnBlur: function OnBlur(e) {
      if (this.m_LastTriggerChangeTime < this.m_LastInputTime) {
        this.EmitChange();
      }
    },
    OnClick: function OnClick(e) {
      this.$emit("click", e);
    },
    ConvertToBoolean: function ConvertToBoolean(string) {
      switch (string.toLowerCase().trim()) {
        case "true":
        case "yes":
        case "1":
          return true;

        case "false":
        case "no":
        case "0":
        case null:
          return false;

        default:
          return Boolean(string);
      }
    },
    ConvertElementToDataObject: function ConvertElementToDataObject(dataNode) {
      var childNode;
      var childObject;
      var dataObject = null;
      var leafNode = false;
      var controlChildCount = 0;
      var propertyName;
      var dataSource = null;
      var parentDataPropertyName;
      var i, j;

      if (dataNode != null) {
        if ((dataSource = dataNode.getAttribute("Source")) != null) {
          parentDataPropertyName = dataSource.replace("parentData.", "");

          if (this.$data != null) {
            dataObject = this.GetValueByPropertyPath(this.$data, parentDataPropertyName);
          }
        } else if (dataNode.getAttribute("Type") == "Array") {
          dataObject = [];
        } else if (dataNode.getAttribute("Type") == "Object") {
          dataObject = {};
        } else if (dataNode.getAttribute("Type") == "Number") {
          dataObject = new Number(dataNode.innerHTML);
          leafNode = true;
        } else if (dataNode.getAttribute("Type") == "Boolean") {
          dataObject = this.ConvertToBoolean(dataNode.innerHTML);
          leafNode = true;
        } else if (dataNode.getAttribute("Type") == "Text" || dataNode.getAttribute("Type") == "Html") {
          dataObject = dataNode.innerHTML;
          leafNode = true;
        } else if (dataNode.getAttribute("Type") == null && dataNode.children.length > 0) {
          dataObject = dataNode.innerHTML;
          leafNode = true;
        } else if (dataNode.children.length == 0) {
          dataObject = dataNode.innerHTML;
          leafNode = true;
        }
      }

      if (!leafNode && dataSource == null) {
        for (i = 0; i < dataNode.children.length; i++) {
          childNode = dataNode.children[i];

          if (childNode.tagName.toLowerCase() != "control") {
            childObject = this.ConvertElementToDataObject(childNode);

            if (dataNode.getAttribute("Type") == "Object") {
              if (childNode.getAttribute("PropertyName") != null) {
                propertyName = childNode.getAttribute("PropertyName");
              } else {
                propertyName = childNode.tagName.toLowerCase();
              }

              if (propertyName.indexOf("m_") != 0) {
                dataObject[propertyName] = childObject;
              }
            } else if (dataNode.getAttribute("Type") == "Array") {
              dataObject.push(childObject);
            } else {
              throw "Error ! Non object type data has more than one child !";
            }
          }
        }
      }

      return dataObject;
    },
    //end ConvertElementToDataObject
    GetValueByPropertyPath: function GetValueByPropertyPath(sourceDataObject, propertyPath) {
      var resultData = null;
      var tokens;
      var i;
      tokens = propertyPath.split(".");

      try {
        resultData = sourceDataObject;

        for (i = 0; i < tokens.length; i++) {
          resultData = resultData[tokens[i]];
        }
      } catch (ex) {
        resultData = null;
        console.log(ex);
      }

      return resultData;
    },
    //end  GetValueByPropertyPath(sourceDataObject,propertyPath) {
    HasParentPlugableControl: function HasParentPlugableControl(controlElement) {
      var parentElement;
      var hasParentControl = false;
      parentElement = controlElement.parentElement;

      while (true) {
        if (parentElement.tagName == "CONTROL") {
          hasParentControl = true;
          break;
        } else if (parentElement.tagName == "BODY") {
          break;
        } else {
          parentElement = parentElement.parentElement;
        }
      }

      return hasParentControl;
    },
    GetVueInstance: function GetVueInstance() {
      return this;
    },
    BindPartial: function BindPartial() {
      this.BindControlOnEditingAreaControlElements(false);
    },
    BindAll: function BindAll() {
      this.BindControlOnEditingAreaControlElements(true);
    },
    BindControlOnEditingAreaControlElements: function BindControlOnEditingAreaControlElements() {
      var _this = this;

      var clearInstances = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var controlElements;
      var firstLevelControlElements = [];
      var dataSource;
      var dataSourceUrl = null;
      var options = {};
      var i;

      if (clearInstances) {
        this.ClearControlInstanceVues();
      }

      if (this.$refs == null || this.$refs.EditingArea == null) {
        return;
      }

      controlElements = this.$refs.EditingArea.querySelectorAll("control");

      for (i = 0; i < controlElements.length; i++) {
        if (!this.HasParentPlugableControl(controlElements[i])) {
          firstLevelControlElements.push(controlElements[i]);
        }
      }

      try {
        for (i = 0; i < firstLevelControlElements.length; i++) {
          var controlType = "";
          var controlElement = void 0;
          var dataElement = void 0,
              propsElement = void 0;
          var dataObject = null,
              propsObject = null,
              parentDataObject = null;
          var controlPath = void 0;
          var componentPath = void 0;
          var folderPath = void 0;
          var pageRequest = {};
          controlElement = firstLevelControlElements[i];
          controlElement.setAttribute("v-on:change", this.OnChildControlChange);
          controlType = controlElement.getAttribute("Type");
          componentPath = controlElement.getAttribute("Path");

          if (componentPath != null) {
            componentPath = componentPath.replace("/Src/Pages", "");
            componentPath = componentPath.replace("/Pages", "");
          }

          propsElement = controlElement.querySelector("props");

          if (propsElement != null) {
            propsElement.setAttribute("Type", "Object");
            propsObject = this.ConvertElementToDataObject(propsElement);
          }

          dataElement = controlElement.querySelector("data");

          if (dataElement != null) {
            dataElement.setAttribute("Type", "Object");

            if ((dataSourceUrl = dataElement.getAttribute("SourceUrl")) != null) {} else if ((dataSource = dataElement.getAttribute("Source")) != null) {
              if (dataSource.indexOf("parentData.") == 0) {
                var parentDataPropertyName = void 0;
                parentDataPropertyName = dataSource.replace("parentData.", "");

                if (this.$data != null) {
                  dataObject = this.GetValueByPropertyPath(this.$data, parentDataPropertyName);
                }
              }
            } else {
              dataObject = this.ConvertElementToDataObject(dataElement);
            }
          }

          options = {
            ComponentPath: componentPath,
            DataObject: dataObject,
            PropsObject: propsObject,
            ControlElement: controlElement,
            ControlType: controlType
          };

          if (dataSourceUrl != null) {
            pageRequest = {};
            apiService.Post(dataSourceUrl, pageRequest).then(function (responseData) {
              options.DataObject = responseData;

              _this.BuildControl(options);
            }).catch(function (ex) {
              alert(ex);
              throw ex;
            });
          } else {
            this.BuildControl(options);
          }
        } //end for (i = 0; i < controlElements.length; i++) {

      } catch (e) {
        debugger;
        alert(e);
      }
    },
    //end BindControlOnEditingAreaControlElements
    BuildControl: function BuildControl(options) {
      var componentPath;
      var controlType;
      componentPath = options.ComponentPath;
      controlType = options.ControlType;

      if (componentPath != null) {
        import("/Src/Pages" + componentPath).then(this.MountControlHandler.bind(this, options)).catch(function (e) {
          alert(e);
        });
      } else {
        import("/Src/PlugableControls/" + controlType).then(this.MountControlHandler.bind(this, options)).catch(function (error) {
          alert(error);
          throw error;
        });
      }
    },
    //MountControlHandler(dataObject, propsObject,controlElement, module) {
    MountControlHandler: function MountControlHandler(options, module) {
      var controlId;
      var originalData = null;
      var toAssignData = null;
      var toAssignProps = null;
      var controlType;
      var dataObject, propsObject, controlElement;
      var v;
      dataObject = options.DataObject;
      propsObject = options.PropsObject;
      controlElement = options.ControlElement;
      controlType = controlElement.getAttribute("Type");

      if (dataObject != null) {
        //module.default.data = dataObject;
        if (module.default.data == null) {
          module.default.data = dataObject;
        } else {
          toAssignData = {};

          if (typeof module.default.data == "function") {
            originalData = module.default.data();
          } else {
            originalData = module.default.data;
          }

          for (var i in originalData) {
            toAssignData[i] = originalData[i];
          }

          for (var i in dataObject) {
            if (i.indexOf("m_") != 0) {
              toAssignData[i] = dataObject[i];
            }
          }
        }

        module.default.data = toAssignData;
      }

      if (propsObject != null) {
        //module.default.data = dataObject;
        if (module.default.props == null) {
          module.default.props = propsObject;
        } else {
          toAssignProps = {};

          for (var i in propsObject) {
            if (i.indexOf("m_") != 0) {
              toAssignProps[i] = propsObject[i];
            }
          }
        }

        module.default.propsData = toAssignProps;
      }

      controlId = "ControlElement_" + PlugableControlBase.ElementSerialNo++;
      module.default.data.ControlId = controlId;
      module.default.data.ControlType = controlType;
      module.default.router = routeConfig;
      v = new Vue(module.default);
      v.$parent = this;
      v.$mount(controlElement);
      this.m_ControlInstanceVues.push(v);
    },
    GetRichHtml: function GetRichHtml() {
      var richHTML;
      var beginRegex = /<!--Control (ControlElement_[0-9]+) Begin-->/i;
      var beginMatch;
      var controlId;
      var headHtml, tailHtml;
      var controlXml;
      var beginCommentText, endCommentText;
      var beginCommentStartIndex, endCommentStartIndex;
      var dataAttributeRegex = /data-v-[a-z|0-9]+="[^"]*"/ig;
      var controlVueInstance = null;
      var i;
      this.CreateBeginEndComments();
      richHTML = this.$refs.EditingArea.innerHTML;
      richHTML = richHTML.replace(dataAttributeRegex, "");

      while (true) {
        beginMatch = beginRegex.exec(richHTML);

        if (beginMatch == null) {
          break;
        }

        beginCommentStartIndex = beginMatch.index;
        controlId = beginMatch[1];
        endCommentText = "<!--Control " + controlId + " End-->";
        endCommentStartIndex = richHTML.indexOf(endCommentText);
        headHtml = richHTML.substr(0, beginCommentStartIndex); //controlXml = this.GenerateControlXml(controlId);

        controlVueInstance = this.GetVueInstanceByControlId(controlId);
        controlXml = controlVueInstance.GetControlXml();
        tailHtml = richHTML.substr(endCommentStartIndex + endCommentText.length);
        richHTML = headHtml + controlXml + tailHtml;
      } //end  while (true) {


      this.RemoveBeginEndComments();
      return richHTML;
    },
    //GetRichHtml(
    GetVueInstanceByControlId: function GetVueInstanceByControlId(controlId) {
      var controlVueInstance = null;
      var i;

      for (i = 0; i < this.m_ControlInstanceVues.length; i++) {
        if (this.m_ControlInstanceVues[i].$data.ControlId == controlId) {
          controlVueInstance = this.m_ControlInstanceVues[i];
          break;
        }
      }

      return controlVueInstance;
    },
    OnChildControlChange: function OnChildControlChange(childControlVueInstance) {
      var newValue;
      this.m_LastInputTime = new Date();

      if (this.$refs.EditingArea.querySelector("[controlinstance]") != null) {
        //要把 BorserHtml 轉換為 RichHtml
        newValue = this.GetRichHtml();
      } else {
        newValue = this.$refs.EditingArea.innerHTML;
      }

      this.EmitChange();
    },
    EmitChange: function EmitChange() {
      var newValue;
      this.m_LastInputTime = new Date();

      if (this.$refs.EditingArea.querySelector("[controlinstance]") != null) {
        //要把 BorserHtml 轉換為 RichHtml
        newValue = this.GetRichHtml();
      } else {
        newValue = this.$refs.EditingArea.innerHTML;
      }

      this.RichHtml = newValue;
      this.$emit("input", newValue);
      this.$emit("change", newValue);
      this.m_LastTriggerChangeTime = new Date();

      if (this.$parent.OnChildControlChange != null) {
        this.$parent.OnChildControlChange();
      }
    },
    CreateBeginEndComments: function CreateBeginEndComments() {
      var _this2 = this;

      var beginCommentNode, endCommentNode;
      var controlElement;
      var controlId;
      this.m_ControlInstanceVues.forEach(function (vueInstance) {
        controlElement = vueInstance.$el;
        controlId = controlElement.getAttribute("ControlId");
        beginCommentNode = document.createComment("Control ".concat(controlId, " Begin"));
        controlElement.parentNode.insertBefore(beginCommentNode, controlElement);

        _this2.m_CommentNodes.push(beginCommentNode);

        endCommentNode = document.createComment("Control ".concat(controlId, " End"));
        controlElement.parentNode.insertBefore(endCommentNode, controlElement.nextSibling);

        _this2.m_CommentNodes.push(endCommentNode);
      });
    },
    RemoveBeginEndComments: function RemoveBeginEndComments() {
      this.m_CommentNodes.forEach(function (commentNode) {
        commentNode.remove();
      });
      this.m_CommentNodes.length = 0;
    },
    ClearControlInstanceVues: function ClearControlInstanceVues() {
      var i;
      this.m_ControlInstanceVues.forEach(function (controlInstanceVue) {
        controlInstanceVue.$destroy();
      });

      for (i = 0; i < this.m_ControlInstanceVues.length; i++) {
        delete this.m_ControlInstanceVues[i];
      }

      this.m_ControlInstanceVues.length = 0;
    },
    DestoryBindControls: function DestoryBindControls() {
      this.ClearControlInstanceVues();
    }
  },
  mounted: function mounted() {
    PlugableControlBase.call(this); //RichHtml 有可能是從 上個 RichHtml 的內文設定

    if (this.RichHtml == "" || this.RichHtml == null) {
      this.RichHtml = this.value;
    }

    this.m_BrowserHtml = this.RichHtml;
    this.$forceUpdate();
    setTimeout(function () {
      this.BindControlOnEditingAreaControlElements();
    }.bind(this), 1);
  },
  beforeMounted: function beforeMounted() {},
  beforeDestroy: function beforeDestroy() {
    console.log("RichEditor destory");
    this.DestoryBindControls();
  },
  created: function created() {},
  components: {},
  watch: {
    value: function value(newVal, oldVal) {
      var currTime = new Date();

      if (currTime - this.m_LastTriggerChangeTime > 500) {
        this.RichHtml = this.value;
        this.m_BrowserHtml = this.RichHtml;
        this.$forceUpdate();
        setTimeout(function () {
          this.BindControlOnEditingAreaControlElements();
        }.bind(this), 1);
      }
    }
  }
};